/**
 * Every Planner event, as one typed union (KTD12). Each is sent once, from the side that
 * knows the fact: refusals and state changes from the Worker, views from the browser. The
 * two lists are the ownership; a name in both would be counted twice.
 *
 * There is no `course_chosen`: the course is committed by Draft my year or Start blank, and
 * `draft_requested` and `plan_created_blank` already carry it. A third event would send the
 * same fact twice.
 */
export const SERVER_ACTIONS = [
  // The gate.
  'access_denied', 'subscription_refused',
  // Draft my year. A draft alone is not built (R22).
  'draft_requested', 'plan_drafted', 'draft_failed', 'quota_refused',
  // The plans API. `plan_built` is sent once per plan, when R22 is first met.
  'plan_created_blank', 'plan_built', 'current_unit_set', 'plan_edited', 'still_on_this',
  'overrun_resolved', 'calendar_saved', 'plan_deleted',
  // Day items and spans (KTD7).
  'span_moved', 'day_item_added', 'day_item_edited', 'day_item_deleted',
  // Collab attachments (KTD8). Collab sends its own event for the upload it stores.
  'material_attached', 'collab_upload_completed', 'collab_upload_refused',
] as const;
export const BROWSER_ACTIONS = [
  // Views and the access states.
  'page_viewed', 'plan_list_viewed', 'weekly_viewed', 'overrun_shown', 'topic_opened', 'topic_error_shown',
  'kill_switch_shown', 'subscription_preview_shown',
  // Clicks out of the tool or to retry it.
  'subscription_cta_clicked', 'access_retry_clicked', 'labs_clicked',
  // Hand-offs from a day item (KTD7).
  'brush_up_clicked', 'lesson_check_clicked',
  // The planbook's zoom, once per change of level (KTD7), and Previous or Next at a level.
  'planbook_zoomed', 'planbook_stepped',
] as const;
export type ServerAction = typeof SERVER_ACTIONS[number];
export type BrowserAction = typeof BROWSER_ACTIONS[number];
export type PlannerAction = ServerAction | BrowserAction;
export type EventName = `preview_planner_${PlannerAction}`;
export interface AnalyticsEvent { name: EventName; properties: Record<string, string | number | boolean | string[]> }
export function plannerEvent(action: PlannerAction, properties: AnalyticsEvent['properties'] = {}): AnalyticsEvent {
  return { name: `preview_planner_${action}`, properties };
}
